import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './Reserve.module.css';
import { Login as LoginIcon, Logout, Person } from '@mui/icons-material';
import { auth } from '../utils/firebase';
import HeaderActions from '../components/Header/HeaderActions';
// 나중에 예약 관련 카드 데이터가 생기면 import
// import reserveCardTexts from '../data/reserveCardTexts.json'; 
// import CheckCard from '../components/CheckCard/CheckCard';

const Reserve: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { hospitalId } = useParams();
  const prefix = hospitalId ? `/${hospitalId}` : '';

  const handleMyInfo = () => {
    navigate(`${prefix}/my-info`);
  };

  const isLoggedIn = auth.currentUser !== null;

  const handleLoginClick = () => {
    navigate(`${prefix}/login`);
  };

  const handleLogout = async () => {
    const confirmLogout = window.confirm(t('logout_confirm', '로그아웃 하시겠습니까?'));
    if (confirmLogout) {
      await auth.signOut();
      localStorage.clear();
      navigate(`${prefix}/`);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <span className={styles.logoText}>BrainCheck</span>
        </div>
        <HeaderActions hospitalId={hospitalId} />
      </div>

      <div className={styles.cardsContainer}>
        <div className={styles.cardsScroll}>
          {/* 여기에 예약 관련 카드를 배치하거나, 준비중 텍스트 표시 */}
          <div style={{ 
            color: 'white', 
            fontSize: '1.2rem', 
            textAlign: 'center', 
            fontWeight: 500 
          }}>
            {t('reserve_coming_soon', '예약 페이지 준비 중입니다.')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reserve;